import { filterForCurrentBid } from '../../../../helpers';

export function getQuoteUrl(data) {
  const currentBidArr = filterForCurrentBid(data.Bids);
  return currentBidArr[0].QuoteUrl;
}
